import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicFloorFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M1.82 5.26l5.91 2.68c.17.08.37.08.54 0l5.91-2.68c.42-.2.42-.83 0-1.02L8.27 1.56a.65.65 0 00-.54 0L1.82 4.24c-.43.2-.43.83 0 1.02zM14.18 7.5l-1.47-.67-4.1 1.86a1.46 1.46 0 01-1.22 0L3.3 6.83l-1.47.67c-.43.19-.43.83 0 1.02l5.91 2.68c.17.07.37.07.54 0l5.91-2.68c.43-.2.43-.83 0-1.02zm0 3.24l-1.46-.66-4.11 1.86a1.46 1.46 0 01-1.22 0l-4.1-1.86-1.47.66c-.43.2-.43.83 0 1.02l5.91 2.68c.17.08.37.08.54 0l5.91-2.68c.43-.19.43-.82 0-1.02z" />
    </svg>
  );
}

SvgBasicFloorFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicFloorFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicFloorFilled svgRef={ref} {...props} />
));
export default ForwardRef;
